import { Clock, MapPin, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurHeadquarters() {
  return <section data-section-id="222618" id="our-headquarters" className="relative w-full h-[75vh] min-h-[550px] bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-secondary/20">
        <iframe title="AI Tech Solutions Headquarters Location" src="https://maps.google.com/maps?q=155%20Princess%20St,%20Kangaroo%20Point,%20QLD%204169,%20Australia&t=&z=15&ie=UTF8&iwloc=&output=embed" className="w-full h-full border-0 filter grayscale-[80%] invert-[90%] hue-rotate-[180deg] brightness-[0.7] contrast-[1.2] opacity-80" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        {}
        <div className="absolute inset-0 bg-primary/10 mix-blend-overlay pointer-events-none"></div>
      </div>

      {}
      <div className="absolute bottom-6 left-4 right-4 md:bottom-12 md:left-12 md:right-auto md:w-[440px] z-10">
        <Card className="bg-card/80 backdrop-blur-md border-border/30 shadow-2xl rounded-lg">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-3xl text-primary tracking-tight">
              Visit Our Tech Hub
            </CardTitle>
            <CardDescription className="text-base mt-2 font-sans text-muted-foreground">
              Experience the future of autonomous support at our Australian headquarters, where AI innovation meets efficiency.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="bg-accent/20 p-2 rounded-lg shrink-0">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div className="pt-1">
                <h4 className="font-default font-semibold text-foreground mb-1">Location</h4>
                <p className="font-mono text-sm text-muted-foreground leading-relaxed">
                  155 Princess St. Kangaroo Point,<br />
                  QLD, 4169 Australia
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-accent/20 p-2 rounded-lg shrink-0">
                <Clock className="w-5 h-5 text-primary" />
              </div>
              <div className="pt-1">
                <h4 className="font-default font-semibold text-foreground mb-1">Operational Hours</h4>
                <p className="font-mono text-sm text-muted-foreground leading-relaxed">
                  Mon - Fri: 08:00 - 18:00<br />
                  Sat: 09:00 - 13:00 (AEST)
                </p>
              </div>
            </div>
          </CardContent>
          <CardFooter className="pt-2">
            <Button className="w-full h-12 text-base font-default font-medium shadow-lg bg-primary text-primary-foreground hover:opacity-90 transition-all rounded-lg" asChild>
              <Link to="https://maps.google.com/?q=155+Princess+St,+Kangaroo+Point,+QLD+4169,+Australia" newTab>
                <Navigation className="w-5 h-5 mr-2" />
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}